import { Component } from '@angular/core';
import { CellViewBase } from '../base';

@Component({
    selector: 'fi-checklist-report-view-checkpoints-per-unit-table-cell-view-empty',
    template: '',
    standalone: false,
})
export class EmptyComponent extends CellViewBase {}
